import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import TabBar from 'src/App/Components/Tabs/TabBar';
import { COLOR_PRIMARY_2 } from 'src/colors';
import ComingSoon from './ComingSoon';
import CurrencyChangeMenu from 'src/App/HOC/CurrencyChangeMenu';

const CurrencyTab = ({ currency, setCurrency }: { currency: string; setCurrency: any }) => {

  return (
    <Box
      sx={{
        width: 'clamp(250px, 50%, 500px)',
        '& .MuiMenuItem-root': {
          pl: 0,
        },
      }}
    >
      <CurrencyChangeMenu
        currency={currency}
        setCurrency={setCurrency}
        fullWidth={true}
        handleDefaultCurrencyOnly={true}
      />
    </Box>
  );
};

const ProductSettingsTab = ({
  currency,
  setCurrency,
  OverviewLandingPageComponent,
  EstimatorDashboardComponent,
  isMobileScreen,
}: {
  currency: string;
  setCurrency: any;
  OverviewLandingPageComponent: JSX.Element;
  EstimatorDashboardComponent: JSX.Element;
  isMobileScreen: boolean;
}) => {
  const [tabSelected, setTabSelected] = useState<string>('currency');

  const tabsList = [
    {
      label: 'Currency',
      value: 'currency',
      onclick: () => {
        setTabSelected('currency');
      },
      component: <CurrencyTab currency={currency} setCurrency={setCurrency} />,
    },
    {
      label: 'Saved Markets',
      value: 'saved_markets',
      onclick: () => {
        setTabSelected('saved_markets');
      },
      component: OverviewLandingPageComponent,
    },
    {
      label: 'Saved Reports',
      value: 'saved_reports',
      onclick: () => {
        setTabSelected('saved_reports');
      },
      component: EstimatorDashboardComponent,
    },
    {
      label: 'Saved Filters',
      value: 'saved_filters',
      onclick: () => {
        setTabSelected('saved_filters');
      },
      component: <ComingSoon />,
    },
    {
      label: 'Data Export History',
      value: 'data_export_history',
      onclick: () => {
        setTabSelected('data_export_history');
      },
      component: <ComingSoon />,
    },
  ];

  return (
    <>
      <TabBar
        tabList={tabsList}
        currentTab={tabSelected}
        color={COLOR_PRIMARY_2}
        renderLabelCondition={() => true}
        actionButton={<></>}
        showActionButton={false}
        isMobile={isMobileScreen}
      />
      <Box sx={{ py: '10px', position: 'relative', width: '100%' }}>
        {tabsList.map(tab => {
          if (tab.value === tabSelected) {
            return tab.component;
          }
          return <></>;
        })}
      </Box>
    </>
  );
};

export default ProductSettingsTab;
